import React from 'react';
import { Box } from '@mui/material';
import InterveneOrganisationSearchableSelect from '../../../intervene/components/InterveneOrganisationSearchableSelect';
import { getOrganisationId } from '../../../intervene/utils/organisationSelectUtils';

export default function OrganisationPicker({ organisation, onChange, sx }) {
  return (
    <Box sx={{ minWidth: { xs: '100%', sm: 280 }, ...sx?.orgFilter }}>
      <InterveneOrganisationSearchableSelect
        label="Organisation"
        valueId={getOrganisationId(organisation)}
        selectedOrganisation={organisation}
        onChange={onChange}
      />
    </Box>
  );
}
